import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { BackendResponse, entityName } from '@qtek/shared/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpEntityManager } from '../http-entity-manager';

export interface StepperDataPayload {
  stepperName: string;
  step: number;
  jsonData: string;
}

export interface StepperDataResponse {
  _id: string;
  jsonData: string;
  step: number;
  stepperName: string;
  userId: string;
}

@Injectable({
  providedIn: 'root',
})
export class StepperDataService extends HttpEntityManager<
  StepperDataResponse,
  StepperDataResponse
> {
  protected http = inject(HttpClient);

  protected entityName: entityName = 'StepperData';

  constructor() {
    super();
  }

  getStepperData(
    stepperName: string
  ): Observable<BackendResponse<StepperDataResponse | null>> {
    return this.http
      .get<BackendResponse<StepperDataResponse[]>>(this.baseURL, {
        ...this.baseRequestOptions,
        params: this.searchParams({ stepperName }),
      })
      .pipe(
        map(response => ({
          ...response,
          res: response.res?.[0] ?? null,
        }))
      );
  }

  /** The API upserts by `(user, stepperName)`, so every save is a create. */
  createStepperData(
    payload: StepperDataPayload
  ): Observable<BackendResponse<StepperDataResponse>> {
    return this.post(payload);
  }

  deleteStepperData(
    id: string
  ): Observable<BackendResponse<StepperDataResponse>> {
    return this.delete(id);
  }
}
